module.exports = __webpack_public_path__ + "img/404pad.bcb840f3.svg";